module.exports = __webpack_public_path__ + "img/uploaded-cross.7bf0af86.svg";